"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconStyles = exports.IconPositions = exports.ButtonSizes = void 0;
var ButtonSizes = ['small', 'large'];
exports.ButtonSizes = ButtonSizes;
var IconPositions = ['left', 'right'];
exports.IconPositions = IconPositions;
var iconStyles = function iconStyles(buttonSize) {
  return buttonSize === 'large' ? 'h-[24px] w-[24px]' : 'h-[16px] w-[16px]';
};
exports.iconStyles = iconStyles;